import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({
  className,
  type,
  autoCorrect,
  autoCapitalize,
  spellCheck,
  style,
  ...props
}, ref) => {
  const normalizedType = String(type || "text").toLowerCase()
  const shouldDisableCorrections = ["email", "password", "tel", "url", "search"].includes(normalizedType)
  const resolvedAutoCorrect = autoCorrect ?? (shouldDisableCorrections ? "off" : undefined)
  const resolvedAutoCapitalize =
    autoCapitalize ?? (["email", "password", "url"].includes(normalizedType) ? "none" : undefined)
  const resolvedSpellCheck = spellCheck ?? (shouldDisableCorrections ? false : undefined)
  const resolvedStyle =
    normalizedType === "password"
      ? {
          fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          ...style,
        }
      : style

  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-lg border border-input bg-white px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-white file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      autoCorrect={resolvedAutoCorrect}
      autoCapitalize={resolvedAutoCapitalize}
      spellCheck={resolvedSpellCheck}
      style={resolvedStyle}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }

